import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Asana = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      id="asana_layer"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="hsl(from hsl(0 82% 68%) h s 50%)"
      d="M17.2,11.6c-2.6,0-4.8,2.2-4.8,4.9c0,2.7,2.1,4.9,4.8,4.9s4.8-2.2,4.8-4.9
	C22,13.8,19.9,11.6,17.2,11.6z M4.8,11.6c-2.6,0-4.8,2.2-4.8,4.9c0,2.7,2.1,4.9,4.8,4.9c2.6,0,4.8-2.2,4.8-4.9
	C9.6,13.8,7.4,11.6,4.8,11.6z M15.8,5.5c0,2.7-2.1,4.9-4.8,4.9c-2.6,0-4.8-2.2-4.8-4.9c0-2.7,2.1-4.9,4.8-4.9
	C13.6,0.5,15.8,2.7,15.8,5.5z"
    />
  </svg>
);
